import React from 'react';

interface CardProps {
    title: string;
    description?: string;
    link?: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, description, link, onClick, children }) => {
    const content = (
        <div
            onClick={onClick}
            className="border border-black p-4 space-y-2 hover:bg-black hover:text-white transition-colors cursor-pointer group"
        >
            <h3 className="text-sm font-bold uppercase">{title}</h3>
            {description && <p className="text-xs">{description}</p>}
            {children}
            {link && <div className="text-[10px] pt-2">[ visit ]</div>}
            {onClick && !link && <div className="text-[10px] pt-2">[ open ]</div>}
        </div>
    );

    if (link) {
        return <a href={link} target="_blank" rel="noopener noreferrer" className="block">{content}</a>;
    }

    return content;
};

export default Card;
